import { DocumentsService } from '@/openapi';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/util/queryKeys';

interface UploadDocumentParams {
  dirName: string;
  doc: Blob;
}

export const useUploadDocumentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UploadDocumentParams) => {
      return DocumentsService.documentsServiceUploadDocument({ body: params });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.documents.list() }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.documents.metadata(),
        }),
      ]);
    },
  });
};
